import React from 'react';

// components
import ConfirmationCta from './ConfirmationCta';
import Icon from 'shared/components/Icon';

import './styles.scss';

const ConfirmationPageDetails = ({ ctaProps, backgroundImg }) => (
  <div className="confirmation-page-details">
    <ConfirmationCta {...ctaProps} />
    <Icon icon={backgroundImg} className="background" />
  </div>
);

export default ConfirmationPageDetails;
